
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/promotion/open-event-2021",
      function () {
        return require("private-next-pages/promotion/open-event-2021.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/promotion/open-event-2021"])
      });
    }
  